import { Box, Stack } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";

import { MaterialPermission } from "commons/enum/permission";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { AddMaterial } from "../add-material/add-material";
import { MaterialGroupSelectionConnected } from "../shared-components";
import { UpdateMaterial } from "../update-material/update-material";
import { MaterialTable } from "./material-table";

export const MaterialList = observer(() => {
  const {
    materialStore: {
      pagination,
      getMaterials,
      openNew,
      openEdit,
      setProp,
      queryParams: { code, name, type, barcode, setProp: setQueryParamProp },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getMaterials();
  }, [getMaterials, pagination]);
  return (
    <>
      <PageFilterContainer
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          gap={1}
        >
          <MaterialGroupSelectionConnected
            codeSelected={code}
            typeSelected={type}
            nameSelected={name}
            barcodeSelected={barcode}
            setSelectionProp={setQueryParamProp}
          ></MaterialGroupSelectionConnected>

          <SearchButton asyncAction={onSearch}></SearchButton>
        </Stack>
        <Box>
          <AddButton
            accessPermission={[MaterialPermission.Create]}
            onClick={() => {
              setProp("openNew", true);
            }}
          >
            Thêm vật tư
          </AddButton>
        </Box>
      </PageFilterContainer>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <MaterialTable></MaterialTable>
      </PageContentContainer>

      <>
        {openNew && <AddMaterial></AddMaterial>}
        {openEdit && <UpdateMaterial></UpdateMaterial>}
      </>
    </>
  );
});
